import React, { memo } from 'react';

const LoadingDiv = () => <div id="generic-loadingdiv">Loading...</div>;

export default memo(LoadingDiv);
